import React from "react";

export default function FILTVNowPlaying({ channel, ad }) {
    if (!channel) return null;

    return (
        <div className="rounded-xl p-3 bg-gradient-to-r from-purple-700 to-pink-600">
            <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                    <div className="text-[10px] tracking-wider text-purple-100 font-semibold">
                        NOW PLAYING • LCN {channel.lcn}
                    </div>

                    <div className="font-bold text-base sm:text-lg leading-tight truncate">
                        {channel.emoji} {channel.title}
                    </div>

                    <div className="text-xs mt-1 text-purple-100 truncate">
                        {ad
                            ? `Sponsored by ${ad.merchant}${ad.city ? ` • ${ad.city}` : ""}`
                            : "No sponsor live on this channel right now"}
                    </div>
                </div>

                {ad?.offer && (
                    <div className="text-right shrink-0">
                        <div className="text-[10px] text-purple-100">TODAY'S OFFER</div>
                        <div className="text-sm font-bold">{ad.offer}</div>
                    </div>
                )}
            </div>

            <div className="mt-2 text-[11px] text-yellow-200">
                🔥 Watch 5 min to start earning Streak Points
            </div>
        </div>
    );
}
